import { render, staticRenderFns } from "./PreloaderProgress.vue?vue&type=template&id=524dc6d2&lang=pug&"
import script from "./PreloaderProgress.vue?vue&type=script&lang=js&"
export * from "./PreloaderProgress.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports